<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card>
      <v-card-title>{{ isEditing ? 'Edit Asset' : 'Upload Asset' }}</v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            v-model="name"
            label="Name *"
            outlined
            autofocus
            :rules="[Required('Name')]"
          />
          <v-file-input
            v-if="!isEditing"
            v-model="file"
            label="File *"
            accept=".pdf,.doc,.docx,.png,.jpg,.jpeg"
            outlined
            :rules="[v => !!v || 'File is required']"
          />
          <v-text-field
            v-else
            :value="asset.fileName"
            label="File"
            outlined
            readonly
            hint="Re-uploading isn't supported. Upload a new asset instead."
            persistent-hint
          />
          <v-switch v-if="isEditing" v-model="isActive" label="Active" />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('close')">Cancel</v-btn>
        <v-btn color="primary" @click="handleSave">{{ isEditing ? 'Save' : 'Upload' }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import Required from '@/lib/formValidations/required'

export default {
  props: {
    asset: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      dialog: true,
      name: this.asset ? this.asset.name : null,
      isActive: this.asset ? this.asset.isActive : true,
      file: null
    }
  },
  computed: {
    isEditing () {
      return !!(this.asset && this.asset.id)
    }
  },
  methods: {
    ...mapActions('workflowLibraryAsset', ['uploadWorkflowLibraryAsset', 'saveWorkflowLibraryAsset']),
    Required,
    handleSave () {
      if (!this.$refs.form.validate()) return

      if (this.isEditing) {
        this.$store.commit('workflowLibraryAsset/setWorkflowLibraryAsset', { ...this.asset, name: this.name, isActive: this.isActive })
        this.saveWorkflowLibraryAsset()
          .then(response => {
            if (!response.data) return
            this.$emit('saved')
          })
          .catch(() => {})
      } else {
        this.uploadWorkflowLibraryAsset({ name: this.name, file: this.file })
          .then(response => {
            if (!response.data) return
            this.$emit('saved')
          })
          .catch(() => {})
      }
    }
  }
}
</script>
